import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Qué recibo al comprar?',
  answer: 'Recibís acceso inmediato a todos los PDFs del plan que elegiste: los tomos, los bonos y el upsell si corresponde. Todo en formato digital A4, listo para imprimir o usar en pantalla.'
}, {
  question: '¿Cuándo me llega?',
  answer: 'El acceso es inmediato. Apenas confirmado el pago, recibís el enlace de descarga en tu email en menos de 5 minutos.'
}, {
  question: '¿Es físico o digital?',
  answer: 'Es 100% digital en formato PDF. Podés imprimirlo tantas veces como necesites o usarlo directamente desde la pantalla en la cancha.'
}, {
  question: '¿Necesito ser instructor certificado?',
  answer: 'No. El material está diseñado para cualquier docente de polo, instructor, entrenador o persona que enseñe polo independientemente de su certificación formal.'
}, {
  question: '¿Tengo acceso para siempre?',
  answer: 'Sí. El acceso es de por vida. Una vez que comprás, el material es tuyo para siempre.'
}, {
  question: '¿Qué pasa si no me llega el acceso?',
  answer: 'Escribinos por WhatsApp al número de Martín Alvarado (1172344089) o por email a soporte@rincondocente360.com y lo resolvemos en menos de 1 hora.'
}, {
  question: '¿Es una compra segura?',
  answer: 'Sí. El pago se procesa a través de Mercado Pago con toda la seguridad y protección al comprador que ofrece la plataforma.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-12 md:py-24 bg-polo-navyLight border-t border-white/5" data-id="element-31">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-32">
        <div className="text-center mb-8 md:mb-16" data-id="element-33">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-34">
            Resolvé tus dudas
          </h2>
        </div>

        <div className="space-y-3 md:space-y-4 mb-10 md:mb-16" data-id="element-35">
          {faqs.map((faq, index) => <div key={index} className="glass-card rounded-xl overflow-hidden border-white/10" data-id="element-36">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 py-4 md:px-6 md:py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-37">
                <span className="text-base md:text-lg font-medium text-white pr-4 md:pr-8" data-id="element-38">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-polo-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-39" />
              </button>

              <AnimatePresence data-id="element-40">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-41">
                    <div className="px-4 pb-4 md:px-6 md:pb-5 text-sm md:text-base text-gray-300 leading-relaxed border-t border-white/5 pt-3 md:pt-4" data-id="element-42">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        <div className="text-center" data-id="element-43">
          <button onClick={scrollToPricing} className="w-full sm:w-auto bg-polo-gold hover:bg-polo-goldHover text-polo-navy font-bold text-lg md:text-xl py-4 px-8 md:py-5 md:px-10 rounded-xl shadow-[0_0_30px_rgba(201,168,76,0.3)] transition-all hover:scale-105 active:scale-95" data-id="element-44">
            👉 Quiero acceder ahora sin riesgo
          </button>
        </div>
      </div>
    </section>;
}